import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';
import { QRCodeSVG } from 'qrcode.react';

const printQR = (qrAsset) => {
  const qrEl = document.getElementById('asset-qr-printable');
  if (!qrEl) return;
  const w = window.open('', '_blank', 'width=400,height=600');
  if (!w) return;

  // Build the print document with safe DOM APIs (no document.write / innerHTML
  // for user-controlled fields, which avoids XSS via asset metadata).
  const doc = w.document;
  doc.open();
  doc.close();

  const title = doc.createElement('title');
  title.textContent = `Asset QR — ${qrAsset?.asset_id || ''}`;
  doc.head.appendChild(title);

  const style = doc.createElement('style');
  style.textContent = `body{font-family:sans-serif;text-align:center;padding:24px;}
    h2{margin:8px 0;font-size:18px;}p{margin:2px 0;font-size:12px;color:#555;}
    .tag{font-family:monospace;font-size:14px;border:1px dashed #999;padding:6px 10px;display:inline-block;margin-top:8px;}`;
  doc.head.appendChild(style);

  const body = doc.body;
  body.appendChild(qrEl.cloneNode(true));

  const h2 = doc.createElement('h2');
  h2.textContent = qrAsset?.name || '';
  body.appendChild(h2);

  const tag = doc.createElement('div');
  tag.className = 'tag';
  tag.textContent = qrAsset?.asset_id || '';
  body.appendChild(tag);

  const metaLine = doc.createElement('p');
  metaLine.textContent = `${qrAsset?.category || ''} · ${qrAsset?.location || ''}`;
  body.appendChild(metaLine);

  const org = doc.createElement('p');
  org.textContent = 'Suubi Community Development Org';
  body.appendChild(org);

  w.onload = () => { w.print(); setTimeout(() => w.close(), 300); };
  setTimeout(() => { try { w.print(); } catch (e) { /* popup already closed */ } }, 200);
};

export const AssetQrDialog = ({ qrAsset, onClose }) => (
  <Dialog open={!!qrAsset} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-sm" data-testid="asset-qr-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading">Asset QR Code</DialogTitle>
        <DialogDescription>Print and stick on the asset for quick scan check-in/out.</DialogDescription>
      </DialogHeader>
      {qrAsset && (
        <div className="flex flex-col items-center gap-3 py-2">
          <div id="asset-qr-printable" className="bg-white p-3 rounded-lg border">
            <QRCodeSVG
              value={JSON.stringify({
                type: 'suubi-asset',
                asset_id: qrAsset.asset_id,
                id: qrAsset.id,
                name: qrAsset.name,
              })}
              size={200}
              level="M"
              includeMargin={false}
            />
          </div>
          <div className="text-center">
            <p className="font-semibold">{qrAsset.name}</p>
            <p className="font-mono text-xs text-muted-foreground">{qrAsset.asset_id}</p>
            {qrAsset.location && (
              <p className="text-xs text-muted-foreground capitalize mt-1">
                {qrAsset.category?.replace(/_/g, ' ')} · {qrAsset.location?.replace(/_/g, ' ')}
              </p>
            )}
          </div>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Close</Button>
        <Button onClick={() => printQR(qrAsset)} data-testid="print-qr-btn">Print Label</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
